'use strict';

var objFit = require('obj-fit');
var appDom = require('../../app-dom');
var controls = require('./controls');

var setMinHeightofLeftRightVideoLayout = function() {
	const layouts = document.querySelectorAll('.video-left-right-layout');
	
	for (var layout of layouts) {
		const children = layout.children;

		let minHeight = Infinity;

		for (var child of children) {
			const videoPlayer = child.querySelector('.video-layout__player');
			if(!videoPlayer) return;

			child.style.height = 'auto';
			minHeight = videoPlayer.offsetHeight;
		}
		const videoContentElm = layout.querySelector('.video-layout__content');
		videoContentElm.style.height = minHeight + 'px';
	}
}

var setAspectRatio = function() {
	var iframes = document.querySelectorAll(".video-banner-layout.no-crop iframe");
	if (iframes.length <= 0) return;
	iframes.forEach( function(el) {
		var setRatio = function() {
			var ratio = el.width && el.height ? (el.width / 10) +'/'+(el.height / 10) : '16/9';
			el.style.setProperty('aspect-ratio', ratio);
			el.removeEventListener("load", setRatio, false);
		};
		if (document.body.contains(el)) {
			el.addEventListener("load", setRatio);
		}
	});
}

var init = function() {
	
	controls.init();

	setAspectRatio();

	// window.addEventListener('load', setMinHeightofLeftRightVideoLayout);

	// let resizeTimeout;
	// window.addEventListener('resize', function() {
	// 	clearTimeout(resizeTimeout);
	// 	resizeTimeout = setTimeout(setMinHeightofLeftRightVideoLayout, 100);
	// });

	if (appDom.content.find('[data-video-block-obj-fit]').length) {

		objFit.create({
			dataAttributeName: 'video-block-obj-fit',
			target: '[data-video-block-obj-fit]'
		});

	}

};

module.exports = {
	init: init
};
